import React, { memo } from 'react'
import { useLoader, LoaderProps } from './useLoader'
import styles from './Loader.module.scss'

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  const {} = useLoader(props)

  return (
    <div className={styles['loader-container']}>
      <div className={styles.loader}></div>
    </div>
  )
}

export default memo(Loader)
